export function hasWorkspaceShell(doc = typeof document !== 'undefined' ? document : null) {
  if (!doc) {
    return false;
  }

  return Boolean(
    doc.getElementById('dashboardsTreeView') ||
      doc.getElementById('chatsTreeView') ||
      doc.getElementById('submitNewDashForm') ||
      doc.getElementById('submitNewChatForm') ||
      doc.querySelector('.grid-stack')
  );
}

export function hasAdminQueryList(doc = typeof document !== 'undefined' ? document : null) {
  if (!doc) {
    return false;
  }

  return Boolean(doc.getElementById('all-queries'));
}
